import { render, staticRenderFns } from "./CommissionSplit.vue?vue&type=template&id=6d6215cc&"
import script from "./CommissionSplit.vue?vue&type=script&lang=js&"
export * from "./CommissionSplit.vue?vue&type=script&lang=js&"
import style0 from "./CommissionSplit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports